import { generatePath } from 'react-router-dom';

import type { ContactReferenceTypeValue } from '@/api/address-book/types';
import { ContactReferenceType } from '@/api/address-book/types';
import { PagePaths } from '@/routes/page-paths';

import { contactTypeLabel } from './contact-groups';

export const UNNAMED_CONTACT = 'Unnamed contact';

const PERSON_REFERENCE_TYPES: string[] = [
  ContactReferenceType.Individual,
  ContactReferenceType.External,
];

export const referenceTypeLabel = (referenceType: ContactReferenceTypeValue): string =>
  contactTypeLabel(referenceType);

export const isPersonReferenceType = (referenceType: ContactReferenceTypeValue): boolean =>
  PERSON_REFERENCE_TYPES.includes(referenceType);

export const contactTitle = (contact: { name: string | null }): string =>
  contact.name?.trim() || UNNAMED_CONTACT;

export type ContactHrefSource = {
  id: string;
  referenceType: string | null;
  referenceId: string | null;
};

export const toContactHref = (contact: ContactHrefSource): string => {
  if (contact.referenceType === ContactReferenceType.Entity) {
    return generatePath(PagePaths.addressBookEntity, { id: contact.id });
  }

  return contact.referenceId
    ? generatePath(PagePaths.userProfile, { id: contact.referenceId })
    : generatePath(PagePaths.addressBookContact, { id: contact.id });
};
